// extracted by mini-css-extract-plugin
module.exports = {"box":"Box_box__N1qGY","title":"Box_title__dVpdC","stack":"Box_stack__kejn0","stackOnMobile":"Box_stackOnMobile__EASNZ","footer":"Box_footer__wI1eg"};